import styled from "styled-components";

export const PlusButton = styled.button`
  &&&& {
    font-family: "Lato", "Helvetica Neue", Arial, Helvetica, sans-serif;
    background: none;
    border: none;
    height: 100%;
    padding: 10px;
    cursor: pointer;
    max-height: 40px;
    i {
      background-color: transparent !important;
    }
    &:hover {
      background-color: #dcdfec;
      border-radius: 4px;
    }
    &.advanced {
      color: #007ac6;
    }
  }
`;
